import { serviceTypes, modulesConfig } from '../config';

export const moduleId = 'Occupancy';

export const modulePath = serviceTypes[modulesConfig.Occupancy.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
